<p>No messages found. To troubleshoot, please check the following causes:</p>
<ul class="steps steps-vertical">
  <li class="step"><span class="text-left">Satellite passes over the location of your device.</span></li>
  <li class="step"><span class="text-left">Device placed free of obstructions, not near a wall or under a tree.</span></li>
  <li class="step"><span class="text-left">If you have multiple devices, make sure there is at least 1m of space in between.</span></li>
  <li class="step"><span class="text-left">Device is turned on.</span></li>
  <li class="step"><span class="text-left">Batteries are full and placed correctly.</span></li>
</ul>
<p>Check the manual for additional information.</p>
<p>Contact support&#64;lacuna-space.com if your issues persist.</p>
